function patientConsentModelFactory(Model) {
  function PatientConsentModel(modelName, data) {
    Model.call(this, modelName, data);
  }

  PatientConsentModel.prototype = Object.create(Model.prototype);

  PatientConsentModel.prototype.getReconsentDate = function(patient) {
    var myDate = new Date(patient.dateOfBirth);
    myDate.setFullYear(myDate.getFullYear() + 16);
    return myDate.toISOString();
  };

  return PatientConsentModel;
}

patientConsentModelFactory.$inject = ['Model'];

export default patientConsentModelFactory;



/** WEBPACK FOOTER **
 ** ./src/app/patients/consents/consent-model.js
 **/